"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Snapchat = function Snapchat(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 12,23.25c-1.172-0.168-2.24-0.762-3-1.67c-0.666-0.665-1.612-0.967-2.54-0.81l-0.64,0.11 c-0.71,0.14-1.399-0.322-1.539-1.032C4.243,19.653,4.249,19.452,4.3,19.26c0.103-0.435-0.152-0.874-0.58-1l-2-0.41 c-0.45-0.133-0.708-0.605-0.575-1.055c0.07-0.237,0.24-0.433,0.465-0.535c0.912-0.374,1.775-0.858,2.57-1.44 c0.601-0.45,0.724-1.302,0.275-1.904c-0.1-0.134-0.223-0.248-0.365-0.336L2.86,11.8c-0.707-0.453-0.913-1.393-0.46-2.1c0,0,0,0,0,0 c0.486-0.708,1.443-0.906,2.17-0.45l1.32,0.84v-3.2c0.137-3.388,2.994-6.024,6.383-5.887c3.196,0.129,5.758,2.691,5.887,5.887v3.19 l1.32-0.84c0.727-0.456,1.684-0.258,2.17,0.45c0.453,0.707,0.247,1.647-0.46,2.1c0,0,0,0,0,0l-1.23,0.78 c-0.636,0.4-0.827,1.24-0.426,1.875c0.089,0.141,0.203,0.265,0.336,0.365c0.795,0.582,1.658,1.066,2.57,1.44 c0.428,0.193,0.618,0.697,0.425,1.125c-0.102,0.226-0.297,0.396-0.535,0.465l-2,0.41c-0.428,0.126-0.683,0.565-0.58,1 c0.176,0.702-0.25,1.413-0.952,1.589c-0.176,0.044-0.359,0.051-0.538,0.021l-0.64-0.11c-0.928-0.157-1.874,0.145-2.54,0.81 C14.304,22.492,13.203,23.096,12,23.25z",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
Snapchat.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Snapchat.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Snapchat;